/** Hide/remove the pre-React LCP shell once the real UI has painted. Never reloads. */

let dismissed = false;

export function dismissTbStaticShell(): void {
  if (typeof document === 'undefined') return;
  dismissed = true;
  document.documentElement.classList.add('tb-app-ready');
  document.getElementById('tb-static-shell')?.remove();
}

/** Static “Book online” is a hash link; the target lives in the React tree under the overlay. */
export function activateTbStaticShellBookCta(): void {
  if (typeof document === 'undefined') return;
  dismissTbStaticShell();
  const book = document.getElementById('book-now');
  if (book) {
    book.scrollIntoView?.({ behavior: 'smooth', block: 'start' });
    return;
  }
  if (window.location.hash !== '#book-now') {
    window.location.hash = 'book-now';
  }
}

export function hideTbStaticShellForSession(): void {
  if (typeof document === 'undefined') return;
  document.documentElement.classList.add('tb-has-session');
}

/**
 * Wait until React's first fold (or a logged-in/oauth gate) is in the DOM,
 * then drop the static overlay. Inner routes dismiss immediately so lazy
 * pages are not covered. Never reloads, never fetches.
 */
export function scheduleTbStaticShellDismiss(): () => void {
  if (typeof document === 'undefined') return () => {};

  if (document.documentElement.classList.contains('tb-has-session')) {
    dismissTbStaticShell();
    return () => {};
  }

  const path = (window.location.pathname || '/').replace(/\/+$/, '') || '/';
  const isMarketingHome = path === '/' || path === '/m';
  if (!isMarketingHome) {
    const id = window.requestAnimationFrame(() => dismissTbStaticShell());
    return () => window.cancelAnimationFrame(id);
  }

  let cancelled = false;
  let frames = 0;
  const tick = () => {
    if (cancelled || dismissed) return;
    if (
      document.querySelector(
        '[data-tb-first-fold-ready], .hero-section, #root #book-now, #root .home-page',
      )
    ) {
      dismissTbStaticShell();
      return;
    }
    frames += 1;
    if (frames >= 180) {
      dismissTbStaticShell();
      return;
    }
    window.requestAnimationFrame(tick);
  };
  window.requestAnimationFrame(tick);
  return () => {
    cancelled = true;
  };
}
